<template>
  <el-footer style="height:130px;align-items:center">
    <el-row type="flex" class="row-footer" justify="center">
      <el-col :span="5">
        <div class="logo">
          <a href="#" style="text-align:left">
            <img src="@/assets/img/logo.svg" alt="HumPoPG-logo" class="navlogo" width="100px" style="margin-top:8px">
          </a>
          <p>Human Population Omics Group</p>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/article"><el-link :underline="false" type="primary">Publication</el-link></router-link>
        </div>
        <div class="footer-link">
          <router-link style="text-decoration:none" to="/article"><el-link :underline="false">Article</el-link></router-link>
        </div>
        <div class="footer-link">
          <router-link style="text-decoration:none" to="/software"><el-link :underline="false">Software</el-link></router-link>
        </div>
        <div class="footer-link">
          <router-link style="text-decoration:none" to="/db"><el-link :underline="false">Database</el-link></router-link>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/people"><el-link :underline="false" type="primary">People</el-link></router-link>
        </div>
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/news"><el-link :underline="false" type="primary">News</el-link></router-link>
        </div>
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/resource"><el-link :underline="false" type="primary">Resource</el-link></router-link>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/events"><el-link :underline="false" type="primary">Events</el-link></router-link>
        </div>
        <div class="footer-link-primary">
          <router-link style="text-decoration:none" to="/about"><el-link :underline="false" type="primary">About</el-link></router-link>
        </div>
      </el-col>
    </el-row>
  </el-footer>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style scoped>
    .el-footer {
        left: 0;
        bottom: 0;
        padding: 0px;
        margin: 0px;
        width: 100%;
        background: rgb(234, 238, 244);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
    .logo {
      text-align: left;
    }
    .footer-link {
      /* display: inline-block; */
      text-align: left;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .footer-link-primary {
      text-align: left;
      margin-top: 8px;
      margin-bottom: 5px;
    }
    .el-link {
      font-size: 15px;
    }
</style>
